import { allFeaturesAtFalse } from './default';
export const features = {
    ...allFeaturesAtFalse,
    home: {
        ...allFeaturesAtFalse.home,
        advantages: false,
    },
    contact: {
        mailTo: 'contact@countrymalt.com',
    },
    footer: {
        social: {
            facebook: 'https://www.facebook.com/countrymalt',
            linkedin: 'https://www.linkedin.com/company/the-country-malt-group',
            instagram: 'https://www.instagram.com/countrymalt',
            youtube: 'https://www.youtube.com/c/CountryMaltGroup',
        },
        sitemap: [
            {
                title: 'Customer Service',
                links: [
                    {
                        label: 'Order tracking',
                        externalHref: 'https://tracking.countrymalt.com/',
                    },
                    {
                        label: 'Contact us',
                        externalHref: 'https://www.countrymalt.com/contact-us',
                    },
                    {
                        label: 'FAQ',
                        externalHref: 'https://www.countrymalt.com/faq',
                    },
                ],
            },
            {
                title: 'About us',
                links: [
                    {
                        label: 'Blog',
                        externalHref: 'https://resources.countrymalt.com/mashing-in/',
                    },
                    {
                        label: 'Our heritage',
                        externalHref: 'https://www.countrymalt.com/heritage',
                    },
                    {
                        label: 'Careers',
                        externalHref: 'https://www.countrymalt.com/careers',
                    },
                ],
            },
            {
                title: 'Resources',
                links: [
                    {
                        label: 'Customer Guidebook',
                        externalHref: 'https://online.flippingbook.com/view/1045762047/',
                    },
                    {
                        label: 'Customer Guidebook (FR)',
                        externalHref: 'https://online.flippingbook.com/view/461749635/',
                    },
                    {
                        label: 'Malt Analysis',
                        externalHref: 'http://coa.countrymaltgroup.com/Customers',
                    },
                    {
                        label: 'Hop Analysis',
                        externalHref: 'https://www.yakimachief.com/commercial/resources/lot-lookup/',
                    },
                    {
                        label: 'Beyond Beer',
                        externalHref: 'https://www.countrymalt.com/beyond',
                    },
                    {
                        label: 'Community Program',
                        externalHref: 'https://www.countrymalt.com/community',
                    },
                    {
                        label: 'Filson Vest Gold Medal Program',
                        externalHref: 'https://resources.countrymalt.com/gold-medal-program/',
                    },
                    {
                        label: 'Grain to Glass Posters',
                        externalHref: 'https://www.countrymalt.com/posters',
                    },
                    {
                        label: 'Hops Ride Free',
                        externalHref: '  https://www.countrymalt.com/hops-ride-free',
                    },
                    {
                        label: 'Malt Bag Recycling Program',
                        externalHref: 'https://resources.countrymalt.com/malt-bag-recycling-program/',
                    },
                    {
                        label: 'Recipes',
                        externalHref: 'https://www.countrymalt.com/recipes',
                    },
                ],
            },
            {
                title: 'Connect',
                links: [
                    {
                        label: 'Product Feedback',
                        externalHref: 'https://forms.monday.com/forms/72fc8e647f48326a0d21b2dec4f2f996?r=use1',
                    },
                    {
                        label: 'Locations & sales team',
                        externalHref: 'https://resources.countrymalt.com/location-and-sales-team/',
                    },
                    {
                        label: 'Brewdeck Podcast',
                        externalHref: 'https://resources.countrymalt.com',
                    },
                ],
            }
        ],
    },
    plp: {
        offSeasonBadge: true,
    },
    equalWeb: true,
    axeptio: {
        i18n: {
            cases: {
                default: 'cmg-US-en',
                'en-US': 'cmg-US-en',
                'en-CA': 'cmg-CA-en',
                'fr-CA': 'cmg-CA-fr',
            },
        },
    },
    checkoutV2: {
        hasAddOns: true,
        hasPickupPointFree: true
    },
    pdp: {
        templateB2AGFeature: false,
        showOnlyMainImage: false,
        showSupplier: true,
    },
};
//# sourceMappingURL=countrymalt.js.map